import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { ShieldCheck, Cpu } from 'lucide-react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const AIConfigModal: React.FC<Props> = ({ isOpen, onClose }) => {
  const { config, updateConfig } = useApp();
  
  const [apiKey, setApiKey] = useState(config.geminiApiKey || '');

  const handleSave = () => {
      updateConfig({
          geminiApiKey: apiKey
      });
      alert('Konfiguracja AI Google zaktualizowana. Klucz jest teraz przetrzymywany bezpiecznie w bazie SQL.');
      onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-6 max-w-md w-full shadow-2xl relative animate-fade-in">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 font-bold">X</button>
        
        <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
           <Cpu className="text-purple-600"/> Konfiguracja Google Gemini AI
        </h3>

        <div className="space-y-4">
            <div className="bg-purple-50 p-3 rounded text-xs text-purple-800 border border-purple-200">
                <ShieldCheck size={16} className="inline mr-1" />
                Dzięki temu zabezpieczeniu, Twój klucz API nigdy nie trafi do przeglądarki klienta. 
                Cała komunikacja z modelami AI odbywa się przez serwerowy proxy (backend PHP).
                Zalecamy upewnić się, że to klucz na poziomie abonamentowym, zgodny z regulaminem komercyjnym Google.
            </div>

            <div>
                <label className="block text-sm font-bold text-gray-700 mb-1">
                    Klucz Gemini API (Google AI Studio)
                </label>
                <input 
                    type="password"
                    value={apiKey}
                    onChange={(e) => setApiKey(e.target.value)}
                    placeholder="AIzaSy..."
                    className="w-full border border-gray-300 rounded px-3 py-2 font-mono text-sm"
                />
            </div>

            <button 
                onClick={handleSave}
                className="w-full bg-purple-600 text-white font-bold py-2 rounded shadow-md hover:bg-purple-700 transition"
            >
                Zapisz Ustawienia AI
            </button>
        </div>
      </div>
    </div>
  );
};

export default AIConfigModal;
